
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TopicItemProps } from ".";
import { loading, find } from "store/topic";

interface ApiTopicFindByIdInputProps {
    id: number;
}

type ApiTopicFindOutputProps = OutputBaseProps<{ item: TopicItemProps; }, ApiTopicFindByIdInputProps>;

export const apiTopicFindById = async (data: ApiTopicFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiTopicFindOutputProps>(`/api/topic/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};